import App from './App'
import router from './router'
import api from '../../utils/api'
import vueWechatTitle from 'vue-wechat-title'

// import pubHeader from '../../components/pubHeader' // 全局组件头部
import pubHeaderNew from '../../components/pubHeaderNew' 
import pubMenu from '../../components/pubMenu'
import pubFooter from '../../components/pubFooter'
Vue.config.productionTip = false

Vue.use(api)
Vue.use(vueWechatTitle)

// Vue.component('pubHeader', pubHeader)
Vue.component('pubHeaderNew', pubHeaderNew)
Vue.component('pubMenu', pubMenu)
Vue.component('pubFooter', pubFooter)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router, 
    components: { App },
    template: '<App/>'
})

// api.init(function () {
//     console.log('登录了执行')
// }, function () {
//     console.log('未登录执行')
//     window.location.href = '/login.html'
// })
